import { render, staticRenderFns } from "./HomeProductList.vue?vue&type=template&id=515786d7&"
import script from "./HomeProductList.vue?vue&type=script&lang=js&"
export * from "./HomeProductList.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductList.vue?vue&type=style&index=0&id=515786d7&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports